import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from 'moment';
import { Helmet } from 'react-helmet';

import TrackerTitle from '../../components/TrackerTitle';
import ServiceTitle from '../../components/ServiceTitle';
import DateTime from '../../components/DateTime';

import { fetchService } from '../../actions/ServiceAction';
import { fetchRating } from '../../actions/RatingAction';

import { RATING, THEME, API_URL, API_KEY } from '../../configs/global';

import { isDetailView } from '../../actions/MobileAction';

import { getTime } from '../../helpers/Helpers';

import Rater from 'react-rater';

import coronaBannerMegabus from '../../assets/images/megabus/Corona-banner.png';
import downloadIcon from '../../assets/images/download.svg';
import infoIcon from '../../assets/images/info-icon.svg';

let mountInterval;
let updateInterval;

const getTitleLabel = (name) => {
  switch (name) {
    case 'NX':
      return 'National Express Coach Tracker';
    case 'Bus-Eireann':
      return 'Bus-Eireann Coach Tracker';
    case 'Dublin-Express':
      return 'Dublin Express Coach Tracker';
    case 'Megabus':
      return 'megabus CoachTracker';
    case 'WCCE':
      return 'WCCE CoachTracker';
    default:
      return name;
  }
};

const formattingYourRating = (myRating) => {
  return `Your Rating ${myRating}/5`;
};

const showTimeStatus = (stop, index, maxindex, tracking, departure_time_unix) => {
  if (!THEME.REALTIME)
    return <span className="stop-time stop-time--gray"></span>;
  if (THEME.DISABLE_STATE_FIRST_STOP && moment(departure_time_unix * 1000).diff(moment.utc(), 'seconds') > THEME.DISABLE_STATE_FIRST_STOP)
    return <span className="stop-time stop-time--gray"></span>;

  if (index === maxindex - 1 && stop.live_arrival_time_unix && (stop.has_stop_been_passed || stop.has_stop_been_visited)) {
    return stop.live_arrival_time_formatted_local ? (
      stop.live_arrival_time_unix > stop.scheduled_arrival_time_unix + THEME.LATE_OFFSET ? (
        <span className="stop-time stop-time--red">{`Arr ${getTime(
          stop.live_arrival_time_formatted_local
        )}`}</span>
      ) : (
        <span className="stop-time">{`Arr ${getTime(stop.live_arrival_time_formatted_local)}`}</span>
      )
    )  : stop.estimated_departure_time_formatted_local ? (
      stop.estimated_departure_time_unix > stop.scheduled_departure_time_unix + THEME.LATE_OFFSET ? (
        <span className="stop-time stop-time--red">{`Exp ${getTime(
          stop.estimated_departure_time_formatted_local
        )}`}</span>
      ) : (
        <span className="stop-time">{`Exp ${getTime(stop.estimated_departure_time_formatted_local)}`}</span>
      )
    ) : (
      ''
    );
  }

  if (stop.has_stop_been_passed) {
    return stop.live_departure_time_formatted_local ? (
      stop.live_departure_time_unix > stop.scheduled_departure_time_unix + THEME.LATE_OFFSET ? (
        <span className="stop-time stop-time--red">{`Dep ${getTime(
          stop.live_departure_time_formatted_local
        )}`}</span>
      ) : (
        <span className="stop-time">{`Dep ${getTime(stop.live_departure_time_formatted_local)}`}</span>
      )
    )  : stop.estimated_departure_time_formatted_local ? (
      stop.estimated_departure_time_unix > stop.scheduled_departure_time_unix + THEME.LATE_OFFSET ? (
        <span className="stop-time stop-time--red">{`Exp ${getTime(
          stop.estimated_departure_time_formatted_local
        )}`}</span>
      ) : (
        <span className="stop-time">{`Exp ${getTime(stop.estimated_departure_time_formatted_local)}`}</span>
      )
    ) : (
      ''
    );
  }

  if (stop.estimated_arrival_time_formatted_local && stop.estimated_arrival_time_unix > stop.scheduled_arrival_time_unix + THEME.LATE_OFFSET) {
    return (
      <span className="stop-time stop-time--red">{`Exp ${getTime(
        stop.estimated_arrival_time_formatted_local
      )}`}</span>
    );
  }

  if (THEME.SHOW_EXP_TIME && stop.estimated_arrival_time_formatted_local) {
    return (
      <span className="stop-time">{`Exp ${getTime(
        stop.estimated_arrival_time_formatted_local
      )}`}</span>
    );
  }

  if (stop.estimated_departure_time_formatted_local && stop.estimated_departure_time_unix > stop.scheduled_departure_time_unix + THEME.LATE_OFFSET) {
    return (
      <span className="stop-time stop-time--red">{`Exp ${getTime(
        stop.estimated_departure_time_formatted_local
      )}`}</span>
    );
  }

  if (THEME.SHOW_EXP_TIME &&  stop.estimated_departure_time_formatted_local) {
    return (
      <span className="stop-time">{`Exp ${getTime(
        stop.estimated_departure_time_formatted_local
      )}`}</span>
    );
  }

  if (tracking.has_no_vehicle || tracking.has_no_gps)
    return <span className="stop-time stop-time--gray">No tracking</span>;

  return <span className="stop-time">On time</span>;
};

export const calculateDuration = (from, to, stops, fromTime, toTime) => {
  if (from && to) {
    let fromIndex = 0;
    let toIndex = stops.length - 1;
    for (let i = 0; i < stops.length; i++) {
      if (stops[i].id === from || stops[i].internal_id === from || stops[i].must_contain_stop_ids_index === 0) fromIndex = i;
      if (stops[i].id === to || stops[i].internal_id === to || stops[i].must_contain_stop_ids_index === 1) toIndex = i;
    }
    fromTime = stops[toIndex].scheduled_arrival_time_formatted_local;
    toTime = stops[fromIndex].scheduled_departure_time_formatted_local;
  }
  if (fromTime && toTime) {
    var ms = moment(
      fromTime,
      'YYYY-MM-DD HH:mm:ss'
    ).diff(
      moment(toTime, 'YYYY-MM-DD HH:mm:ss')
    );
    var diff = moment.duration(Math.abs(ms));

    if (diff.hours()) return diff.hours() + 'h ' + diff.minutes() + 'm';
    else return diff.minutes() + 'm';
  }
};

const future = (service) => {
  const date = new Date(service.departure_time_formatted_local).setHours(0,0,0,0);
  const currDate = new Date().setHours(0,0,0,0);

  return date > currDate ? true : false;
};

const showRating = (tracking) => {
  return tracking.is_completed ? true : false;
};

export const openMapDef = (props) => {
  props.showMap(props.route);
  props.callbackFromParent(null);
};

export const openMapFit = (props, route, stops) => {
  let index = 0;
  for (let i = 0; i < stops.length; i++) {
    if (stops[i].is_currently_arrived_at_stop || (
      stops[i].estimated_arrival_time_formatted_local &&
      !(
        stops[i].has_stop_been_passed &&
        stops[i].has_stop_been_visited
      ) && (stops[i].sequence && (
          stops[stops[i].sequence - 1].has_stop_been_passed ||
          stops[stops[i].sequence - 1].has_stop_been_bypassed ||
          stops[stops[i].sequence - 1].has_stop_been_visited
        )
      )
    ))
      index = i;
  }
  if (index !== null && stops[index] && route.active_vehicle.current_wgs84_latitude_degrees) {
    props.callbackFromParent([
      [stops[index].wgs84_latitude_degrees, stops[index].wgs84_longitude_degrees],
      [route.active_vehicle.current_wgs84_latitude_degrees, route.active_vehicle.current_wgs84_longitude_degrees],
    ]);
  }
  props.showMap(route);
};

export const getStopName = (str, mobileView = false) => {
  if (str) {
    // eslint-disable-next-line
    let arr = [];
    let positions = [];

    if (str.indexOf(':') !== -1) {
      arr = [
        str.substring(0, str.indexOf(':') + 1).replace(':', ''),
        str
          .substring(str.indexOf(':') + 1)
          .replace(':', '')
          .replace(',', ' ')
          .replace(/\s*\[.*?\]\s*/g, ''),
      ];
      positions = [];

      if (mobileView && arr[0].length > 20) {
        for (let i = 0; i < arr[0].length; i++) {
          if (arr[0][i].match(/[a-z]/) !== null) {
            positions.push(i);
          }
        }

        const index = positions[0] - 1;
        arr = [arr[0].substring(0, index), arr[0].substring(index), arr[1]];
      }

      return arr;
    }

    if (str.indexOf(',') !== -1) {
      arr = [
        str.substring(0, str.indexOf(',') + 1).replace(',', ''),
        str.substring(str.indexOf(',') + 1).replace(',', ''),
      ];
      positions = [];

      if (mobileView && arr[0].length > 20) {
        for (let i = 0; i < arr[0].length; i++) {
          if (arr[0][i].match(/[a-z]/) !== null) {
            positions.push(i);
          }
        }

        const index = positions[0] - 1;
        arr = [arr[0].substring(0, index), arr[0].substring(index), arr[1]];
      }
      return arr;
    }

    if (str.indexOf('/') !== -1) {
      arr = [
        str.substring(0, str.indexOf('/') + 1).replace('/', ''),
        str.substring(str.indexOf('/') + 1).replace('/', ''),
      ];
      positions = [];
      if (mobileView && arr[1].length === 0 && arr[0].length > 20) {
        for (let i = 0; i < arr[0].length; i++) {
          if (arr[0][i].match(/[a-z]/) !== null) {
            positions.push(i);
          }
        }
        const index = positions[0] - 1;
        arr = [arr[0].substring(0, index), arr[0].substring(index), arr[1]];
      }
      return arr;
    }

    if (str.indexOf('(') !== -1 && str.length > 20) {
      return (arr = [
        str.substring(0, str.indexOf('(') - 1),
        str.substring(str.indexOf('(') - 1),
      ]);
    }

    if (str.length > 20) {
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[a-z]/) !== null) {
          positions.push(i);
        }
      }

      let index = positions[0] - 1;

      arr = [str.substring(0, index), str.substring(index)];
      if (mobileView && arr[1].length > 20) {
        let positions = [];
        for (let i = 0; i < arr[1].length; i++) {
          if (arr[1][i].match(/[A-Z]/g) !== null) {
            positions.push(i);
          }
        }
        const index = positions[1];
        if (arr[0].length)
          arr = [arr[0], arr[1].substring(0, index), arr[1].substring(index)];
        else
          arr = [arr[1].substring(0, index), arr[1].substring(index), ""];
      }

      return arr;
    }

    return [str];
  }

  return ['Unknow'];
};

export const getLastUpdate = (alert) =>
  moment
    .duration(moment.utc().diff(moment(alert.last_updated_time_unix)))
    .humanize();

const mapStateToProps = (state) => ({
  route: state.service,
  stops: state.stops,
  mobileScreen: state.mobileScreen,
  services: state.services,
  rating: state.rating,
  enableRating: true,
  myrating: false,
  isMobileScreen: state.mobileScreen,
});

export class ServiceDetails extends Component {
  state = {
    detailsTabIndex: 0,
    stops: [],
    showPrevStops: false,
    showNextStops: false,
    showPrevButton: false,
    showNextButton: false,
    isFilteringMajorStops: false,
    showFilteredStops: true,
  };

  componentWillMount() {
    this.props.isDetailView({
      detailView: true,
    });
  }

  componentDidMount() {
    const {
      match: { params },
      isMobileScreen,
    } = this.props;

    this.props.showStops(true);

    this.fetchServiceDetails(params);
    clearInterval(updateInterval);

    mountInterval = setInterval(() => {
      this.fetchServiceDetails(params);
    }, 30000);

    if (isMobileScreen) {
      setTimeout(() => window.scrollTo(0, 0), 200);
    }

    if (THEME.NAME === 'NX-Bus' && !params.from && !params.to) {
      this.setState({ isFilteringMajorStops: true });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      match: { params },
      isMobileScreen,
      history,
    } = this.props;

    if (
      prevProps.match.params.journeyId !== params.journeyId ||
      prevProps.match.params.route !== params.route ||
      prevProps.match.params.from !== params.from ||
      prevProps.match.params.to !== params.to ||
      prevProps.match.params.dir !== params.dir
    ) {
      if (isMobileScreen) {
        setTimeout(() => window.scrollTo(0, 0), 200);
      }

      this.setState({
        enableRating: true,
        myRating: null,
      });

      this.setState({
        detailsTabIndex: this.props.detailsTabIndex,
      });

      this.fetchServiceDetails(params);

      clearInterval(mountInterval);
      clearInterval(updateInterval);
      if (history.location.pathname.indexOf('debug-trip') === -1)
        updateInterval = setInterval(() => {
          this.fetchServiceDetails(params);
        }, 30000);
    }
  }

  componentWillUnmount() {
    this.props.showStops(false);

    clearInterval(mountInterval);
    clearInterval(updateInterval);

    this.props.isDetailView({
      detailView: false,
    });
  }

  fetchServiceDetails = ({ route, dir, journeyId, linkDate, from, to, stop }) => {
    if (stop)
      from = stop

    this.props.fetchService(
      route,
      dir,
      journeyId,
      linkDate,
      this.props.history.location.pathname.indexOf('debug-trip') !== -1,
      from,
      to,
      () =>
            this.setState({
              stops: this.mapStops(
                this.props.match.params,
                this.state.showPrevStops,
                this.state.showNextStops
              ),
            })
    );
  };

  mapStops = ({ from, to, stop }, isPrev, isNext) => {
    const { stops } = this.props.route;
    let isFrom = false;
    let indexFrom;
    const stopsLen = stops ? stops.length : 0;
    if (!to && !!stopsLen)
      to = stops[stopsLen - 1].stopId;

    if (!from && stop)
      from = stop;
    else if (!from)
      from = stops[0].internal_id;
    
    const renderStops =
      !!stopsLen &&
      stops.map((stop, i) => {
        if (isFrom === false && (from === stop.id || from === stop.internal_id || stop.is_requested_stop_from || stop.must_contain_stop_ids_index === 0)) {
          indexFrom = i;
          isFrom = true;
          this.setState({
            showPrevButton: !(i === 0),
          });

          return {
            ...stop,
            className: `curr ${isPrev && !!indexFrom ? 'curr--start' : ''}`,
          };
        }

        if (to === stop.id || to === stop.internal_id || stop.is_requested_stop_to|| stop.must_contain_stop_ids_index === 1) {
          isFrom = false;

          this.setState({
            showNextButton: !(stopsLen - 1 === i),
          });

          return {
            ...stop,
            className: `curr ${
              isNext && !(stopsLen - 1 === i) ? 'curr--end' : ''
            }`,
          };
        }

        if (isFrom) {
          return {
            ...stop,
            className: 'curr',
          };
        }

        if (isPrev && isNext) {
          return {
            ...stop,
            className: 'prev',
          };
        }

        if (isPrev) {
          return {
            ...stop,
            className: ` ${indexFrom < i ? 'prev--hide' : ''}`,
          };
        }

        if (isNext) {
          return {
            ...stop,
            className: `prev ${indexFrom < i ? '' : 'prev--hide'}`,
          };
        }

        return {
          ...stop,
          className: 'prev prev--hide',
        };
      });

    return renderStops;
  };

  showPrevStops = (e) => {
    this.setState({
      showPrevStops: !this.state.showPrevStops,
      stops: this.mapStops(
        this.props.match.params,
        !this.state.showPrevStops,
        this.state.showNextStops
      ),
    });
  };

  showNextStops = (e) => {
    this.setState({
      showNextStops: !this.state.showNextStops,
      stops: this.mapStops(
        this.props.match.params,
        this.state.showPrevStops,
        !this.state.showNextStops
      ),
    });
  };

  showFilteringStops = () => {
    this.setState({ showFilteredStops: !this.state.showFilteredStops });
  };

  rate = (reference, rate) => {
    const URL = `${API_URL}/submit-trip-rating-v1/${reference}/${rate.rating}?api_key=${API_KEY}`;
    fetch(URL);
    this.setState({
      enableRating: false,
      myRating: rate.rating,
    });
  };

  render() {
    const {
      route,
      layovers,
      mobileScreen,
      match,
      services,
      toggleInfoModal,
      toggleFreqInfoModal,
      rating
    } = this.props;
    const {
      stops,
      showNextButton,
      showPrevButton,
      showPrevStops,
      showNextStops,
      enableRating,
      myRating,
      isFilteringMajorStops,
      showFilteredStops,
    } = this.state;

    let fromStop = null;
    for (let i = 0; i < stops.length; i++) {
      if (stops[i].must_contain_stop_ids_index === 0) fromStop = stops[i];
    }

    RATING.SHOW && route.trip && !rating.chronological_trip_ratings && this.props.fetchRating(route.trip.id);
    const dateFormat = mobileScreen.open
      ? 'ddd D MMM YYYY'
      : THEME.NAME === 'Megabus'
      ? 'ddd D MMM YYYY'
      : 'ddd D MMMM YYYY';

    return (
      <Tabs
        selectedIndex={this.state.detailsTabIndex}
        onSelect={(detailsTabIndex) => this.setState({ detailsTabIndex })}
      >
        <TabList>
          <Tab>Tracker</Tab>
          <Tab
            className={`react-tabs__tab ${
              route.traffic_incidents && route.traffic_incidents.length ? 'react-tabs__tab--traffic' : ''
            }`}
          >
            {`Alerts ${route.traffic_incidents && route.traffic_incidents.length > 0 ? '(' + route.traffic_incidents.length + ')': ''}`}
          </Tab>
        </TabList>
        <TabPanel>
          {route &&
          route.trip ? (
            <div className="live-tracking">
              <TrackerTitle>Tracker</TrackerTitle>
              {(THEME.HIGH_FREQUENCY_SERVICES.includes(route.trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(route.trip.route_id[0])) &&
                <div className='highfreq__info'>
                  <div className='title' onClick={toggleFreqInfoModal()}>High frequency route<img src={infoIcon} height="80%" alt="high frequency route info" /></div>
                </div>
              }
              <div className="live-tracking__title">
                <ServiceTitle className="station--live">
                {route.stops.length ? (
                    <Fragment>
                      {route.stops[0].public_facing_name ? <Fragment>
                      {route.stops[0].public_facing_name.substring(
                          0,
                          route.stops[0].public_facing_name.indexOf(':') + 1
                        )}
                        <span className="subName">
                          {route.stops[0].public_facing_name.substring(
                            route.stops[0].public_facing_name.indexOf(':') + 1
                          )}
                        </span>
                        <span className="to"></span>{' '}
                          {route.stops[route.stops.length - 1].public_facing_name.substring(
                            0,
                            route.stops[route.stops.length - 1].public_facing_name.indexOf(':') + 1
                          )}
                          <span className="subName">
                            {route.stops[route.stops.length - 1].public_facing_name.substring(
                              route.stops[route.stops.length - 1].public_facing_name.indexOf(':') + 1
                            )}
                          </span>
                        </Fragment> : <Fragment>
                          {services.stops[0].chronological_departures[0].trip.departure_location_name} <span className="to"></span>{' '}
                          {services.stops[0].chronological_departures[0].trip.arrival_location_name}
                        </Fragment>}
                      {!!(services && services.request) && (
                        <Helmet>
                          <title>
                            {`${services.stops[0].chronological_departures[0].trip.route_id} ${getTime(
                              services.stops[0].chronological_departures[0].trip.departure_time_formatted_local
                            )} service, ${services.stops[0].chronological_departures[0].trip.departure_location_name} to ${
                              services.stops[0].chronological_departures[0].trip.arrival_location_name
                            } - ${getTitleLabel(THEME.NAME)}`}
                          </title>
                        </Helmet>
                      )}
                    </Fragment>
                  ) : (route.trip && 
                    <Fragment>
                      {route.trip.departure_location_name} <span className="to"></span>{' '}
                      {route.trip.arrival_location_name}
                    </Fragment>
                  )
                  }
                </ServiceTitle>

                {route.trip && (
                  <span className="route">{route.trip.route_id.replace(/^PPB/, '').replace(/^BZ/, '')}</span>
                )}
              </div>

              <div>

              {THEME.ROUTES_PDF_LINK && route.trip && (
                  <div className="pdf-download">
                    <a href={`${THEME.ROUTES_PDF_LINK}/?origin=${route.trip.departure_location_name}&dest=${route.trip.arrival_location_name}&privateCode=${route.trip.route_id}&departDate=${moment(match.linkDate).format('YYYY-MM-DD')}`} target="_blank" rel="noreferrer">
                      {moment(match.linkDate).format('Do MMM')} PDF <img src={downloadIcon} alt="toward" />
                    </a>
                  </div>
                )}

                {route.trip && (
                  <DateTime
                    date={fromStop ? moment(fromStop.scheduled_departure_time_formatted_local).format(
                      dateFormat) : moment(route.trip.departure_time_formatted_local).format(
                      dateFormat
                    )}
                    time={fromStop ? getTime(fromStop.scheduled_departure_time_formatted_local) : getTime(route.trip.departure_time_formatted_local)}
                  />
                )}

                <div
                  onClick={toggleInfoModal(route)}
                  className="results-service__info"
                >
                  <span>Journey Info</span>
                </div>
              </div>

              <p className="live-tracking__info">
                <span>Operator: {route.trip.class_name}</span>
                <span>
                  Duration:{' '}
                  {route.trip &&
                    calculateDuration(
                      match.params.from,
                      match.params.to,
                      route.stops,
                      route.trip.departure_time_formatted_local ? route.trip.departure_time_formatted_local : null,
                      route.trip.arrival_time_formatted_local ? route.trip.arrival_time_formatted_local : null
                    )}
                </span>
              </p>

              <button
                className="button button--see-map"
                onClick={() => {
                  openMapDef(this.props);
                }}
              >
                See Map
              </button>
              {RATING.SHOW &&
                route.tracking &&
                showRating(
                  route.tracking
                ) && (
                  <div className="rate-text">
                    <span>
                      {myRating
                        ? 'Thank you for your feedback.'
                        : 'Please rate our service'}
                    </span>
                    <Rater
                      interactive={enableRating}
                      total={5}
                      rating={myRating ? myRating : rating && rating.chronological_trip_ratings && rating.chronological_trip_ratings.length ? rating.chronological_trip_ratings[0].rating : null}
                      onRate={this.rate.bind(
                        this,
                        route.trip.id
                      )}
                    />
                    <span className={myRating ? 'your_rating' : 'our_rating'}>
                      {myRating
                        ? formattingYourRating(myRating)
                        : rating && rating.chronological_trip_ratings && rating.chronological_trip_ratings.length && rating.chronological_trip_ratings[0].rating === 0
                        ? ''
                        : 'Our average rating'}
                    </span>
                  </div>
                )}
              {showPrevButton && stops.length > 2 && !isFilteringMajorStops && (
                <button
                  className={`button-stop ${
                    showPrevStops ? 'button-stop--open-top' : ''
                  }`}
                  onClick={this.showPrevStops}
                >
                  {showPrevStops ? 'Hide previous stops' : 'See previous stops'}
                </button>
              )}
              <div>
                <table className="live-tracking__table">
                  <tbody>
                    {!!stops.length &&
                      stops
                        .filter((stop, index) => {
                          if (
                            isFilteringMajorStops &&
                            showFilteredStops &&
                            stop.is_timingPoint
                          ) {
                            return stop;
                          } else if (
                            !showFilteredStops ||
                            !isFilteringMajorStops
                          ) {
                            return stop;
                          }
                          return null;
                        })
                        .map((stop, index) =>
                          (
                            <tr
                              key={v4()}
                              className={`${
                                !THEME.REALTIME ? 'future'
                                : stop.estimated_arrival_time_formatted_local &&
                                !(
                                  stop.is_currently_arrived_at_stop &&
                                  stop.has_stop_been_passed &&
                                  stop.has_stop_been_visited
                                ) && (stop.sequence && route.stops[stop.sequence - 1] && (
                                  route.stops[stop.sequence - 1].has_stop_been_passed ||
                                  route.stops[stop.sequence - 1].has_stop_been_bypassed ||
                                  route.stops[stop.sequence - 1].has_stop_been_visited
                                )
                                  )
                                ? 'next_stop'
                                :
                                !(
                                  stop.is_currently_arrived_at_stop ||
                                  stop.has_stop_been_passed ||
                                  stop.has_stop_been_visited
                                ) ? 'future'
                                : (stop.has_stop_been_passed || stop.has_stop_been_visited) 
                                  ? 'visited'
                                  :
                                  ''
                              } ${
                                !stop.is_timingPoint
                                  ? 'small'
                                  : ''
                              } ${stop.className} ${THEME.REALTIME && stop.is_currently_arrived_at_stop
                                  ? 'at-stop'
                                  : ''
                              }`}
                            >
                              <td
                                style={
                                  stop.scheduled_departure_time_unix !== stop.scheduled_arrival_time_unix
                                    ? { padding: '20px 0px 10px 18px' }
                                    : {}
                                }
                              >
                                {(THEME.HIGH_FREQUENCY_SERVICES.includes(route.trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(route.trip.route_id[0])) ?
                                  <Fragment>
                                    {stop.estimated_arrival_time_formatted_local ? 'Estimated' : stop.live_arrival_time_formatted_local && index === stops.length - 1 ? 'Arrived' : stop.live_arrival_time_formatted_local ? 'Departed' : 'Scheduled' }
                                      <span
                                      className={`${
                                        !stop.can_board && stop.can_alight &&
                                        stop.scheduled_departure_time_unix === stop.scheduled_arrival_time_unix
                                          ? 'arrow-down'
                                          : ''
                                      } ${
                                        stop.can_board && !stop.can_alight &&
                                        stop.scheduled_departure_time_unix === stop.scheduled_arrival_time_unix
                                          ? 'arrow-up'
                                          : ''
                                      } ${
                                        stop.scheduled_departure_time_unix !== stop.scheduled_arrival_time_unix
                                          ? 'layover__arrive'
                                          : ''
                                      }`}
                                    >
                                      {getTime(
                                        stop.estimated_arrival_time_formatted_local ? stop.estimated_arrival_time_formatted_local : stop.live_arrival_time_formatted_local ? stop.live_arrival_time_formatted_local : stop.scheduled_arrival_time_formatted_local
                                      )}
                                      </span>
                                      {stop.scheduled_departure_time_unix !== stop.scheduled_arrival_time_unix && (
                                      <span className="layover layover__depart">
                                        {getTime(
                                          stop.estimated_departure_time_formatted_local ? stop.estimated_departure_time_formatted_local : stop.live_departure_time_formatted_local ? stop.live_departure_time_formatted_local : stop.scheduled_departure_time_formatted_local
                                        )}
                                      </span>
                                    )}
                                  </Fragment>
                                : <Fragment>
                                  <span
                                    className={`${
                                      !stop.can_board && stop.can_alight &&
                                      stop.scheduled_departure_time_unix === stop.scheduled_arrival_time_unix
                                        ? 'arrow-down'
                                        : ''
                                    } ${
                                      stop.can_board && !stop.can_alight &&
                                      stop.scheduled_departure_time_unix === stop.scheduled_arrival_time_unix
                                        ? 'arrow-up'
                                        : ''
                                    } ${
                                      stop.scheduled_departure_time_unix !== stop.scheduled_arrival_time_unix
                                        ? 'layover__arrive'
                                        : ''
                                    }`}
                                  >
                                    {getTime(
                                      stop.scheduled_arrival_time_formatted_local
                                    )}
                                  </span>
                                  {stop.scheduled_departure_time_unix !== stop.scheduled_arrival_time_unix && (
                                    <span className="layover layover__depart">
                                      {getTime(
                                        stop.scheduled_departure_time_formatted_local
                                      )}
                                    </span>
                                  )}
                                  {
                                    !future(route.trip) &&
                                    showTimeStatus(
                                      stop,
                                      isFilteringMajorStops
                                        ? stop.sequence
                                        : index,
                                      route.stops.length,
                                      route.tracking,
                                      route.trip.departure_time_unix
                                    )}
                                  </Fragment>}
                              </td>
                              <td>
                                <span
                                  onClick={
                                    () => {
                                          openMapFit(
                                            this.props,
                                            route,
                                            route.stops
                                          );
                                        }
                                  }
                                  className={`live-tracking__dot ${
                                    stop.scheduled_departure_time_unix !== stop.scheduled_arrival_time_unix
                                      ? 'live-tracking__dot--layover'
                                      : ''
                                  }`}
                                ></span>
                              </td>
                              <td>
                                <span
                                  style={
                                    getStopName(
                                      stop[THEME.PAGES.DETAILS.STOP]
                                        ? stop[THEME.PAGES.DETAILS.STOP]
                                        : stop.public_facing_name
                                        ? stop.public_facing_name
                                        : stop.name,
                                      mobileScreen.open
                                    ).length > 1
                                      ? {}
                                      : { position: 'relative', top: -2 }
                                  }
                                >
                                  {' '}
                                  {
                                    getStopName(
                                      stop[THEME.PAGES.DETAILS.STOP]
                                        ? stop[THEME.PAGES.DETAILS.STOP]
                                        : stop.public_facing_name
                                        ? stop.public_facing_name
                                        : stop.name,
                                      mobileScreen.open
                                    )[0]
                                  }
                                </span>
                                <span className="stop__details">
                                  {getStopName(
                                    stop[THEME.PAGES.DETAILS.STOP]
                                      ? stop[THEME.PAGES.DETAILS.STOP]
                                      : stop.public_facing_name
                                      ? stop.public_facing_name
                                      : stop.name,
                                    mobileScreen.open
                                  ).length > 1
                                    ? getStopName(
                                        stop[THEME.PAGES.DETAILS.STOP]
                                          ? stop[THEME.PAGES.DETAILS.STOP]
                                          : stop.public_facing_name
                                          ? stop.public_facing_name
                                          : stop.name,  
                                        mobileScreen.open
                                      )[1]
                                    : null}
                                </span>
                                <span className="stop__details">
                                  {getStopName(
                                    stop[THEME.PAGES.DETAILS.STOP],
                                    mobileScreen.open
                                  ).length > 2
                                    ? getStopName(
                                        stop[THEME.PAGES.DETAILS.STOP]
                                          ? stop[THEME.PAGES.DETAILS.STOP]
                                          : stop.public_facing_name
                                          ? stop.public_facing_name
                                          : stop.name,  
                                        mobileScreen.open
                                      )[2]
                                    : null}
                                </span>
                              </td>
                            </tr>
                          )
                        )}
                  </tbody>
                </table>
              </div>
              {showNextButton && stops.length > 2 && !isFilteringMajorStops && (
                <button
                  className={`button-stop button-stop--next ${
                    showNextStops ? 'button-stop--open' : ''
                  }`}
                  onClick={this.showNextStops}
                >
                  {showNextStops ? 'Hide next stops' : 'See next stops'}
                </button>
              )}

              {isFilteringMajorStops && (
                <button
                  className={`button-stop button-stop--next ${
                    showFilteredStops ? 'button-stop--open' : ''
                  }`}
                  onClick={this.showFilteringStops}
                >
                  {showFilteredStops ? 'See all stops' : 'See major stops'}
                </button>
              )}

              {THEME.NAME === 'MegabusCorona' && (
                <div className="key">
                  <a
                    href="https://uk.megabus.com/coronavirus"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{ width: '100%' }}
                      src={coronaBannerMegabus}
                      alt="Coronavirus Info"
                    />
                  </a>
                </div>
              )}
              {(THEME.NAME === 'NX' || THEME.NAME === 'Citylink') && (
                <div className="key">
                  <h3>Key</h3>

                  {((layovers && !!layovers.length) || THEME.NAME === 'Citylink') && (
                    <div className="key__info">
                      <div className="key__time top">
                        <span className="key_layover__arrive"></span>
                        <span style={{ color: '#f4f4f4' }}>.</span>
                        <span className="key_layover__depart"></span>
                        <span className="layover" style={{ color: '#f4f4f4' }}>
                          .
                        </span>
                      </div>
                      <p>
                        The coach will arrive at the first time. After a short
                        break at this stop, it will depart again at the second
                        time.
                      </p>
                    </div>
                  )}

                  <div className="key__info">
                    <div className="key__time">
                      <span className="key_up"></span>
                      <span></span>
                    </div>
                    <p>
                      This is a pick-up stop only, we cannot drop customers off.
                    </p>
                  </div>

                  <div className="key__info">
                    <div className="key__time">
                      <span className="key_down"></span>
                    </div>
                    <p>
                      This is a drop off stop only, we cannot pick customers up.
                    </p>
                  </div>

                  {route.category === 'OuiBus' && (
                    <div className="key__info">
                      <div className="key__time">
                        <span className="key_clock"></span>
                      </div>
                      <p>
                        Please note all times displayed are based on the local
                        time at each stop in the country of travel.
                        <br />
                        <br />
                        The European coaches are blue and pink with the National
                        Express logo on the side. However, other coaches are
                        sometimes used to meet demand at busy times. Please ask
                        a member of staff if you have any difficulty finding
                        your coach and ensure you are at the departure point 15
                        minutes prior to your departure time.
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <p className="station">Service Not Found</p>
          )}
        </TabPanel>
        <TabPanel>
        {route.traffic_incidents && route.traffic_incidents.length ? (
            route.traffic_incidents.map((alert) => (
              <div className="traffic-alert" key={v4()}>
                <h3 className="traffic-alert__title">{alert.summary}</h3>
                <div className="traffic-alert__info">
                  <div className="traffic-alert__status">
                    <p>
                      <span className="bold">Status: </span>
                        {alert.incident_is_severe && 'Severe'}
                        {alert.incident_is_roadworks && 'Roadworks'}
                        {alert.incident_is_weather && 'Weather'}
                    </p>
                    <span
                      className={`bold traffic-alert__clear ${
                        alert.incident_is_finished ? ''
                          : 'traffic-alert__clear--no'
                      }`}
                    >
                      Cleared:
                    </span>
                  </div>
                  <p>
                    <span className="bold">Incident: </span>
                    {alert.description}
                  </p>
                  {alert.updated && (
                    <p className={`icon icon--${alert.type}`}>
                      <span className="bold">Last updated: </span>
                      <span className="updated">
                        {getLastUpdate(alert) + ' ago'}
                      </span>
                    </p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="station">
              No road incidents currently affect this service
            </p>
          )}
        </TabPanel>
      </Tabs>
    );
  }
}

export default connect(mapStateToProps, {
  fetchService,
  isDetailView,
  fetchRating,
})(ServiceDetails);



// WEBPACK FOOTER //
// ./src/containers/service-list/ServiceDetails.js